/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Mass_LeadInputs */

const en_for_whom_mass_lead = /** @type {(inputs: For_Whom_Mass_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle by plan, not by eye.`)
};

const pl_for_whom_mass_lead = /** @type {(inputs: For_Whom_Mass_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa z planem, nie na oko.`)
};

/**
* | output |
* | --- |
* | "Muscle by plan, not by eye." |
*
* @param {For_Whom_Mass_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_mass_lead = /** @type {((inputs?: For_Whom_Mass_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Mass_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_mass_lead(inputs)
	return en_for_whom_mass_lead(inputs)
});